"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectResource',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            unit: undefined,
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        canSave() {
            return this.unit !== undefined;
        },
        saveData() {
            if (this.unit === undefined) {
                return;
            }
            this.onsave({ type: 'resource', resource: this.unit });
        },
    },
});
